module.exports = __webpack_public_path__ + "static/margin-auto-f2fe52a419b29555c0a0605be159cae2.png";